<template>
  <v-dialog v-model="show" @keydown.esc="hide">
    <template v-slot:activator="{ on }">
      <v-chip
        v-on="on"
        small
        class="orange lighten-4 warning--text text--darken-2 text-uppercase"
      >
        <v-avatar
          left
          class="mr-0 text-uppercase"
          data-test="employees-unconfirmedCount"
          ><v-progress-circular
            v-if="$apollo.loading"
            indeterminate
            :size="20"
            color="primary"
          /><a v-else style="text-decoration: underline;"
            >{{ employee.unconfirmedCount }}
          </a></v-avatar
        >

        {{ $t("employees.alert.pendingConfirmationsShort") }}
      </v-chip>
    </template>

    <v-card :loading="$apollo.loading">
      <v-card-title>
        <span class="title text--secondary">
          {{ employee | nameId }} {{ $t("instructions.title").toUpperCase() }}
        </span>
        <v-spacer />
        <v-btn icon @click="hide"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <employee-instructions
        v-if="employeeSignedInstructions"
        :onlyConfirmable="true"
        :employee="employee"
        :instructions.sync="employeeSignedInstructions"
        :tags="employee.tags"
        :modes="employee.modes"
        :instructionGroupFilter="[]"
        @refresh="$apollo.queries.employeeSignedInstructions.refetch()"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import EmployeeInstructions from "@/components/EmployeeInstructions";

import EmployeeInstructionsQuery from "@/graphql/queries/EmployeeInstructions.gql";

export default {
  props: {
    employee: {
      type: Object,
      required: true,
    },
  },
  components: {
    EmployeeInstructions,
  },

  data() {
    return {
      show: false,
    };
  },

  methods: {
    hide() {
      this.show = false;
      this.$emit("refresh");
    },
  },
  apollo: {
    employeeSignedInstructions: {
      query: EmployeeInstructionsQuery,
      variables() {
        return {
          id: this.employee.id,
        };
      },
      update(data) {
        const signedInstructions = [];
        data.employee.instructions.forEach((i) => {
          const version = i.version;
          const signature = version.signatures.find(
            (s) =>
              s.type === "sign" &&
              !s.signatures.find((ss) => ss.type === "revoke")
          );

          const confirmation =
            signature &&
            signature.signatures.find(
              (s) =>
                s.type === "confirm" &&
                !s.signatures.find((ss) => ss.type === "revoke")
            );

          if (signature && !confirmation) {
            signedInstructions.push(i);
          }
        });

        if (signedInstructions.length === 0) {
          this.$store.commit("push_global_message", {
            text: `${this.$t(
              "employees.allSignaturesConfirmed"
            )} ${this.$options.filters.nameId(this.employee)}`,
            color: "success",
          });
          this.hide();
        }

        return signedInstructions;
      },
      skip() {
        return !this.show;
      },
    },
  },
};
</script>
